import React from "react";
import {
    UserGraduationUniversity,
    IdLabelInterface,
} from "../../../../containers/RegistrationLoginPage/types";
import {Field} from "react-final-form";
import SelectV2 from "../../../HTMLEntities/SelectV2";
import {SINGLE_SELECT} from "../../../HTMLEntities/SelectV2/utils";
import {
    composeValidators,
    regRequiredValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";

interface GraduationUniversityInterface {
    configuration: UserGraduationUniversity;
}

const GraduationUniversity: React.FC<GraduationUniversityInterface> = ({
    configuration,
}: GraduationUniversityInterface) => {
    const {selectedValue, values, fieldName} = configuration;

    return (
        <Field<IdLabelInterface>
            name={fieldName}
            validate={composeValidators(regRequiredValidate("Please select graduation university"))}
            validateFields={[]}
            {...(selectedValue ? {initialValue: selectedValue} : {})}
        >
            {(props) => {
                return (
                    <SelectV2
                        placeholder={"Graduation University"}
                        type={SINGLE_SELECT}
                        items={values ?? []}
                        inputRFF={props.input}
                        withSearch={true}
                        isFocused={props?.meta?.active ?? false}
                        isTouched={props?.meta?.touched}
                        error={errorHandler(props?.meta)}
                        selectedOption={selectedValue ? [selectedValue] : undefined}
                        isFilled={typeof props.input.value === "object"}
                    />
                );
            }}
        </Field>
    );
};

export default GraduationUniversity;
